import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

////////////////////////////////////////////////////////////
// ENVIRONMENT VARIABLES
////////////////////////////////////////////////////////////

const enableFrontend = false
const enableBackend = true
const enableDebug = false

////////////////////////////////////////////////////////////
// END ENVIRONMENT VARIABLES
////////////////////////////////////////////////////////////

// Near the top of the file, add a timestamp for debugging
const initTime = new Date().toISOString();

// Check if we're in WordPress admin area
const isWordPressAdmin = window.location.href.includes('/wp-admin/')

// Function to trigger custom event when settings are loaded
function triggerSettingsLoaded() {
  window.dispatchEvent(new Event('smartpress_vueWpSettingsLoaded'));
  if(enableDebug) {
    console.log('smartpress_vueWpSettings loaded and event triggered');
  }
}

// Define initVueApp at the root level
function initVueApp() {
  const mountPoint = document.getElementById('vue-wp-app')
  if(enableDebug) {
    console.log('Vue init attempt:', {
      time: new Date().toISOString(),
      initTime: initTime,
      mountPoint: mountPoint ? {
        id: mountPoint.id,
        parent: mountPoint.parentElement.tagName,
        location: window.location.href
      } : 'Not Found',
      settings: window.smartpress_vueWpSettings ? 'Available' : 'Not Available'
    });
  }

  if (!mountPoint) {
    if(enableDebug) {
      console.error('Vue mount point not found, retrying in 100ms...')
    }
    setTimeout(initVueApp, 100)
    return
  }

  // Make sure settings are available before mounting
  if (!window.smartpress_vueWpSettings) {
    if(enableDebug) {
      console.log('Waiting for WordPress settings...');
    }
    // Only wait a limited time for settings
    let waitCount = 0;
    const waitForSettings = setInterval(() => {
      if (window.smartpress_vueWpSettings || waitCount > 10) {
        clearInterval(waitForSettings);
        if (window.smartpress_vueWpSettings) {
          triggerSettingsLoaded();
        }
        continueInitApp(mountPoint);
      }
      waitCount++;
    }, 100);
    return;
  }

  continueInitApp(mountPoint);
}

// Continue app initialization once everything is ready
function continueInitApp(mountPoint) {
  if(enableDebug) {
    console.log('Mounting Vue app to:', mountPoint)
  }
  
  const app = createApp(App)
  app.use(router)

  app.config.errorHandler = (err, vm, info) => {
    console.error('Vue Error:', err, info)
  }

  app.mount('#vue-wp-app')
  
  if(enableDebug) {
    console.log('Vue app mounted successfully')
  }
}

// Only proceed if the current context is enabled
if ((isWordPressAdmin && enableBackend) || (!isWordPressAdmin && enableFrontend)) {
  if(enableDebug) {
    console.log('Vue app main.js loaded, checking mount conditions:', {
      selector: '#vue-wp-app',
      exists: !!document.getElementById('vue-wp-app'),
      documentReady: document.readyState,
      timestamp: new Date().toISOString(),
      context: isWordPressAdmin ? 'admin' : 'frontend',
      settings: window.smartpress_vueWpSettings ? 'Available' : 'Not Available'
    })
  }

  // Initialize when document is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVueApp)
  } else {
    initVueApp()
  }
} else {
  if(enableDebug) {
    console.log('Vue app disabled for current context:', {
      isAdmin: isWordPressAdmin,
      enableFrontend,
      enableBackend
    })
  }
} 